import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-[#0B1F3A] shadow-[0_1px_0_rgba(255,255,255,0.08)]" data-testid="site-navbar">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" aria-label="Incremental Consulting home" data-testid="nav-logo-link">
          <Logo dark />
        </Link>
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[13.5px] font-medium transition-colors duration-200 ${
                  isActive ? "text-[#C9A227]" : "text-white/75 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="nav-cta-lets-talk"
            className="hidden rounded-md bg-[#C9A227] px-5 py-2.5 text-[13.5px] font-bold text-[#0B1F3A] transition-colors duration-200 hover:bg-[#DDB845] lg:inline-flex"
          >
            Book a conversation
          </Link>
          <button
            className="inline-flex rounded-md p-2 text-white lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="overflow-hidden border-t border-white/10 bg-[#0B1F3A] lg:hidden"
            aria-label="Mobile"
            data-testid="nav-mobile-menu"
          >
            <div className="space-y-1 px-5 py-4">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `block rounded-lg px-3 py-2.5 text-[15px] font-medium ${
                      isActive ? "bg-white/10 text-[#C9A227]" : "text-white/85"
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-cta-lets-talk"
                className="mt-2 block rounded-md bg-[#C9A227] px-5 py-3 text-center text-[15px] font-bold text-[#0B1F3A]"
              >
                Book a conversation
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
